<template>
    <div class="globalLayout">
      
        <!-- <div class="navbar">
           <div class="container">
             <div class="logo"> <img style="cursor:pointer;" @click="clickLogo" src="@/assets/image/logo.png" alt=""> </div>
             <div class="dropdown">
                <el-menu
                  :unique-opened='true'
                  class="el-menu-demo"
                  mode="horizontal"
                  @select="handleSelect"
                  background-color="#143657"
                  text-color="#fff"
                  active-text-color="#fff">
                  <el-submenu index="1">
                     <template slot="title">产品中心</template>
                     <el-menu-item index="1-1">MCU+</el-menu-item>
                     <el-menu-item index="1-2">USB</el-menu-item>
                     <el-menu-item index="1-3">低功耗蓝牙</el-menu-item>
                     <el-menu-item index="1-4">以太网</el-menu-item>
                     <el-menu-item index="1-5">PCI/PCIE</el-menu-item>
                     <el-menu-item index="1-6">单片机外围</el-menu-item>
                     <el-menu-item index="1-7">成品和模块</el-menu-item>
                  </el-submenu>
                  <el-menu-item index="2">应用方案</el-menu-item>
                  <el-submenu index="3">
                     <template slot="title">沁恒社区</template>
                     <el-menu-item index="3-1">技术社区</el-menu-item>
                     <el-menu-item index="3-2">销售社区</el-menu-item>
                  </el-submenu>
                  <el-submenu index="4">
                     <template slot="title">服务支持</template>
                     <el-menu-item index="4-1">样品索取</el-menu-item>
                     <el-menu-item index="4-2">资料下载</el-menu-item>
                     <el-menu-item index="4-3">技术支持</el-menu-item>
                     <el-menu-item index="4-4">销售服务</el-menu-item>
                     <el-menu-item index="4-5">工程变更通知</el-menu-item>
                  </el-submenu>
                  <el-submenu index="5">
                     <template slot="title">关于沁恒</template>
                     <el-submenu index="5-1">
                       <template slot="title">关于我们</template>
                        <el-menu-item index="5-1-1">公司简介</el-menu-item>
                        <el-menu-item index="5-1-2">沁恒科技园</el-menu-item>
                        <el-menu-item index="5-1-3">新闻动态</el-menu-item>
                        <el-menu-item index="5-1-4">荣誉与认知</el-menu-item>
                        <el-menu-item index="5-1-5">法律声明</el-menu-item>
                     </el-submenu>
                     <el-menu-item index="5-2">联系我们</el-menu-item>
                     <el-submenu index="5-3">
                        <template slot="title">加入我们</template>
                        <el-menu-item index="5-3-1">人才理念</el-menu-item>
                        <el-menu-item index="5-3-2">校园招聘</el-menu-item>
                        <el-menu-item index="5-3-3">社会招聘</el-menu-item>
                     </el-submenu>
                   </el-submenu>
                </el-menu>
              </div>
              <div class="more">
                <div class="inputSearch" >
                    <el-input style="height:32px;" v-model="inputValue" placeholder="搜索" @keyup.enter.native="inputSearch">  </el-input>
                    <img @click="inputSearch" style="display:block; position:absolute;left:135px; top:0px;  width:; height:20px; margin-top: 6px; cursor:pointer" src="@/assets/image/left_search.png" alt="">
                 </div>
              </div>
              <div class="tip">
                  <div class="login" id="login" @click="gotoLogin">登录</div>
                  <div class="line"></div>
                  <div class="register" id="register" @click="gotoRegister">注册</div>
                  <div> <img src="@/assets/image/yuyan.png" alt="" style="width: 22px; height: 20px;  margin-top: 4px; margin-left: 8px; margin-right: 3px;"> </div>
                  <div class="language">
                    <el-dropdown  @command="languageCommand">
                        <span class="" style="color:#fff; font-weight: 400; font-size: 16px;">选择语言</span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command='http://www.wch.cn/'>简体中文</el-dropdown-item>
                          <el-dropdown-item command='http://www.wch-ic.com/'>English</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                  </div>
               </div>
           </div>
        </div> -->

        <top-bar ref="topBar" @topbarCategoryId ="topbarCategoryId"></top-bar>
 
      
        <div class="banner" style="">
           <img style="width:100%; height:300px;" :src="bannerSrc" alt="">
        </div>
        <div class="breadCrumb"> <div class="breadContainer" > <span @click="gotoHomePage" style="color:#337ab7; cursor:pointer">首页 </span> / <span @click="gotoCenterPage" style="color:#337ab7;cursor:pointer"> 生态系统 </span> / <span> {{ecoBread}} </span>  </div></div>
        <div class="ecoContent">
            <!-- <ProductCenter/> -->
            <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
                <el-tab-pane label="开发工具" name="first"> <DevelopTool/> </el-tab-pane>
                <el-tab-pane label="在线培训" name="second"> <TrainOnline/> </el-tab-pane>
                <el-tab-pane label="RISC-V大学计划" name="third"> <CollegePlan/> </el-tab-pane>
            </el-tabs>
        </div>
        <div class="footer">
           <div class="content">
             <div class="list">
               <div class="listItem" v-for="(item,index) in listArr" :key="index" >
                 <div class="title">{{item.title}}</div>
                 <div class="splitLine"> <span class="frontLine"></span> <span class="behindLine"></span> </div>
                 <div  class="lis">
                   <div class="li" v-for="(t,i) in item.lis" :key="i"  @click="clickFooterLi(t)">{{t.name}}</div>
                 </div>
               </div>
             </div>
             <div class="bottom">
               <div class="left"> <span @click='gotoLaw' class="law" style="cursor:pointer">法律声明</span> | <span class="touch" style="cursor:pointer" @click="gotoTouch">联系我们</span></div>
               <div class="right"><span class="copyRight" style="cursor:pointer" @click="gotoCopyRight">苏ICP备18001197号</span> Copyright © 2002-2021 南京沁恒微电子股份有限公司. All Rights Reserved  <img @click="gotoSite" style="margin-left:3px; cursor:pointer" src="@/assets/image/pic1.gif" alt=""></div>
             </div>
           </div>
        </div>
        <!-- 提示弹框 -->
        <el-dialog
          title="www.wch.cn 提示"
          :visible.sync="dialogVisible"
          width="25%"
         >
         <span style="font-size:16px;">搜索关键字不能为空</span>
         <span slot="footer" class="dialog-footer">
             <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
         </span>
        </el-dialog>
    </div>
</template>
<script>


 
  import { getAction, postAction } from '@/request/http'//引入封装的get post方法
  import DevelopTool from '@/views/ecosystemModules/developTool.vue'
  import TrainOnline from '@/views/ecosystemModules/trainOnline.vue'
  import CollegePlan from '@/views/ecosystemModules/collegePlan.vue'
  import topBar from './topbar.vue'
  export default {
    name: "productMcuPage",
    // mixins: [JeecgListMixin],
    components: {
      CollegePlan,
      TrainOnline,
      DevelopTool,
      topBar
    },
    data() {
      return {
        navbarArr:[
          {name:'产品中心',trigger:'hover', href:'http://www.wch.cn/products/category/1.html', children:[
            // {name:'MCU+', href:''},
            // {name:'USB', href:'http://www.wch.cn/products/category/1.html'},
            // {name:'低功耗蓝牙', href:'http://www.wch.cn/products/category/63.html'},
            // {name:'以太网', href:'http://www.wch.cn/products/category/4.html#data'},
            // {name:'PCI/PCIE', href:'http://www.wch.cn/products/category/2.html'},
            // {name:'单片机外围', href:'http://www.wch.cn/products/category/3.html'},
            // {name:'成品和模块', href:'http://www.wch.cn/products/category/6.html'},
          ]},
          {name:'应用方案',trigger:'click',href:'http://www.wch.cn/application.html', },
          {name:'沁恒社区',href:'http://www.wch.cn/bbs', children:[
            {name:'技术社区', href:'http://www.wch.cn/bbs/forums/tech.html'},
            {name:'销售社区', href:'http://www.wch.cn/bbs/forums/sale.html'},
          ]},
          {name:'服务支持', trigger:'hover', href:'http://www.wch.cn/services/sale_support.html', children:[
            {name:'样品索取', href:'http://www.wch.cn/services/request_sample.html'},
            {name:'资料下载', href:'http://www.wch.cn/downloads/category/27.html'},
            {name:'技术支持', href:'http://www.wch.cn/services/technical_support.html'},
            {name:'销售服务', href:'http://www.wch.cn/services/sale_support.html'},
            // {name:'工程变更通知', href:'http://www.wch.cn/engineering_change_notification.html'},
          ]},
          {name:'关于沁恒',trigger:'hover', href:'http://www.wch.cn/about_us.html', children:[
            {name:'关于我们', href:'http://www.wch.cn/about_us.html'},
            {name:'联系我们', href:'http://www.wch.cn/contact_us.html'},
            {name:'加入我们', href:'http://www.wch.cn/talentconcept.html'},
          ]},
        ],
        childShow:false,
        moreValue:'',
        moreArr:[
          {label:'产品中心', value:'http://www.wch.cn/products/category/1.html'},
          {label:'应用方案', value:'http://www.wch.cn/application.html'},
          {label:'视频资料', value:'http://www.wch.cn/videos.html'},
          {label:'资料下载', value:'http://www.wch.cn/downloads/category/27.html'},
          {label:'新闻动态', value:'http://www.wch.cn/news.html'},
        ],
        inputValue:'',
        dialogVisible:false,
        listArr:[
          {title:'关于我们',lis:[
            {name:'公司简介',href:'http://www.wch.cn/about_us.html'},
            // {name:'沁恒科技园',href:'http://www.wch.cn/park.html'},
            {name:'新闻动态',href:'http://www.wch.cn/news.html'},
            {name:'荣誉与认证',href:'http://www.wch.cn/certification.html'},
            {name:'法律声明',href:'https://www.wch.cn/statement.html'},
          ]},
          {title:'产品中心',lis:[
            // {name:'MCU+',href:'http://www.wch.cn/products/category/5.html'},
            // {name:'USB',href:'http://www.wch.cn/products/category/1.html'},
            // {name:'低功耗蓝牙',href:'http://www.wch.cn/products/category/63.html'},
            // {name:'以太网',href:'http://www.wch.cn/products/category/4.html'},
            // {name:'PCI/PCIE',href:'http://www.wch.cn/products/category/2.html'},
            // {name:'单片机外围',href:'http://www.wch.cn/products/category/3.html'},
            // {name:'成品与模块',href:'http://www.wch.cn/products/category/6.html'},
          ]},
          {title:'服务支持',lis:[
            {name:'技术电话',href:'http://www.wch.cn/services/technical_support.html#tech-tel'},
            {name:'技术邮箱',href:'http://www.wch.cn/services/technical_support.html#tech-mail'},
            {name:'销售电话',href:'http://www.wch.cn/services/sale_support.html#sales-tel'},
            {name:'销售邮箱',href:'http://www.wch.cn/services/sale_support.html#sales-mail'},
          ]},
          {title:'生态系统',lis:[
            {name:'开发工具',href:'http://wch.cn/ecosystems?development-tools'},
            {name:'在线培训',href:'http://wch.cn/ecosystems?online-training'},
            {name:'RISC-V大学计划',href:'http://wch.cn/ecosystems?rv-university'},//http://192.168.111.125:8268/ecosystems/#/
            // {name:'开发工具',href:'http://192.168.111.125:8268/ecosystems?development-tools/#/'},
            // {name:'在线培训',href:'http://wch.cn/ecosystems?online-training'},
            // {name:'RISC-V大学计划',href:'http://wch.cn/ecosystems?rv-university'},
          ]},
        ],
        activeName: 'first',
        ecoBread:'',
        bannerSrc:'',
        bannerSrcArr:[
          '@/assets/image/tool/banner.png',
          '@/assets/image/train/banner.png',
          '@/assets/image/college/banner.png',
        ],
        url:{ 
        //  productUrl:'/api/product_tables/category/products',//navbar和footer中的产品中心接口
          productUrl:'/api/categories/product',//navbar和footer中的产品中心接口

          footerProUrl:'/api/official/website/categories/sidebar',
       },
      }
    },
    computed: {
    },
    mounted(){
      // this.isLogin()
      // this.getProducts()
      this.getFooterProducts()
      this.showTab()
      console.log('update---2023-06-12')
      
    },
    activated(){
    },
    methods: {
      topbarCategoryId(i) {
      } , 
      handleSelect(key, keyPath) {
        console.log('key----',key);
        if(key=='1-1'){
          window.location.href='http://www.wch.cn/products/category/5.html'
        }
        else if(key=='1-2'){
          window.location.href='http://www.wch.cn/products/category/1.html'
        }
        else if(key=='1-3'){
          window.location.href='http://www.wch.cn/products/category/63.html'
        }
        else if(key=='1-4'){
          window.location.href='http://www.wch.cn/products/category/4.html#data'
        }
        else if(key=='1-5'){
          window.location.href='http://www.wch.cn/products/category/2.html'
        }
        else if(key=='1-6'){
          window.location.href='http://www.wch.cn/products/category/3.html'
        }
        else if(key=='1-7'){
          window.location.href='http://www.wch.cn/products/category/6.html'
        }
        else if(key=='2'){
          window.location.href='http://www.wch.cn/application.html'
        }
        else if(key=='3-1'){
          window.location.href='http://www.wch.cn/bbs/forums/tech.html'
        }
        else if(key=='3-2'){
          window.location.href='http://www.wch.cn/bbs/forums/sale.html'
        }
        else if(key=='4-1'){
          window.location.href='http://www.wch.cn/services/request_sample.html'
        }
        else if(key=='4-2'){
          window.location.href='http://www.wch.cn/downloads/category/27.html'
        }
        else if(key=='4-3'){
          window.location.href='http://www.wch.cn/services/technical_support.html'
        }
        else if(key=='4-4'){
          window.location.href='http://www.wch.cn/services/sale_support.html'
        }
        else if(key=='4-5'){
          window.location.href='http://www.wch.cn/engineering_change_notification.html'
        }
       
        else if(key=='5-1-1'){
          window.location.href='http://www.wch.cn/about_us.html'
        }
        else if(key=='5-1-2'){
          window.location.href='http://www.wch.cn/park.html'
        }
        else if(key=='5-1-3'){
          window.location.href='http://www.wch.cn/news.html'
        }
        else if(key=='5-1-4'){
          window.location.href='http://www.wch.cn/certification.html'
        }
        else if(key=='5-1-5'){
          window.location.href='http://www.wch.cn/statement.html'
        }
        else if(key=='5-2'){
          window.location.href='http://www.wch.cn/contact_us.html'
        }
        else if(key=='5-3-1'){
          window.location.href='http://www.wch.cn/talentconcept.html'
        }
        else if(key=='5-3-2'){
          window.location.href='http://www.wch.cn/recruitment/campus.html'
        }
        else if(key=='5-3-3'){
          window.location.href='http://www.wch.cn/recruitment/joinus.html'
        }
      },
      //点击menu一级菜单
     
      //点击logo跳转首页
      clickLogo(){
        window.location.href='http://www.wch.cn/'
      },
      getSearch(){
        console.log('search参数======',window.location)//?development-tools
      },
      //根据跳转链接的参数判断展示不同的tab
      showTab(){
        let query = window.location.search
        if( query&&query=='?development-tools'){
          this.activeName='first'
        }
        else if( query&&query=='?online-training'){
          this.activeName='second'
        }
        else if( query&&query=='?rv-university'){
          this.activeName='third'
        }
        else{
          this.activeName='first'//first
        }
        this.$nextTick(()=>{
          this.showBanner()//banner图
          this.showBread()//面包屑
          this.getSearch()
        })
      },
      //判断activeName展示不同面包屑
      showBread(){
        if(this.activeName=='first'){
          this.ecoBread='开发工具'
        }
        else if(this.activeName=='second'){
          this.ecoBread='在线培训'
        }
        else{
          this.ecoBread='RISC-V 大学计划'
        }
      },
      //获取cookie
      getCookie(name){
          var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
          if(arr=document.cookie.match(reg))
          return unescape(arr[2]);
          else
          return null;
      },
      //删除cookie
      deleteCookie (cookieName) {
          document.cookie = `${cookieName}=; expires=${new Date(0).toGMTString()}`
      },
      //判断登录状态
      isLogin(){
        // this.deleteCookie('nickname')
        // document.cookie='nickname=admin'
        if(document.cookie.indexOf("nickname=")!=-1){
           document.getElementById('login').innerText=this.getCookie('nickname')
           document.getElementById('register').innerText='退出'
        }
        else{
          document.getElementById('login').innerText='登录'
          document.getElementById('register').innerText='注册'
        }
      },
      //获取navbar和footer中的产品中心
      getProducts(){
        console.info(this.url.productUrl);
        getAction(this.url.productUrl).then((res) => {
          // debugger;
          console.log('navbar的res-----',res)
          if (res.status==200) {
            let arr=[]
            res.data.data.forEach((ele,index)=>{
              arr.push({name:ele.name, href:`http://www.wch.cn/products/category/${ele.id}.html`})
            })
            this.navbarArr[0].children=arr

            this.listArr[1].lis=arr

          } else {
              this.$message.warning(res.data.message);
          }
        }).catch(err=>{
          console.log(err)
        });
      },
      
      //底部 产品中心
      getFooterProducts(){
        getAction(this.url.footerProUrl)
          .then(res => {
            if(res.data.code===0 && res.data.data.length){
              console.log('---footer',res.data.data)
              let arr = []
              res.data.data.forEach((item,index)=>{
                if(item.childCategoriesVOList.length){
                  item.childCategoriesVOList.forEach((t,i)=>{
                    if(t.id!=77){// 过滤 关于青稞内核
                      arr.push(t)
                    }
                  })
                }
              })
              this.listArr[1].lis=arr
            
            }else{
              this.$message.error(res.data.message);res.data.data.forE
            }
        });

      },
      //全部select框
      moreChange(){
        window.location.href=this.moreValue
      },
      //顶部搜索框
      inputSearch(){
        if(this.inputValue){
           window.location.href=`http://www.wch.cn/search?t=all&q=${this.inputValue}`
        }
        else{
          this.dialogVisible=true
        }
      },
      //登录
      gotoLogin(){
        if(document.getElementById('login').innerText=='登录'){
            window.location.href='http://www.wch.cn/login'
        }
        else return
      },
      //注册
      gotoRegister(){
        if(document.getElementById('register').innerText=='注册'){
            window.location.href='http://www.wch.cn/bbs/join'
        }
        else {
          window.location.href='http://www.wch.cn/login'
        }
      },
      //切换语言
      languageCommand(command){
         window.location.href=command
      },
      //跳转首页
      gotoHomePage(){
        window.location.href='http://www.wch.cn/'
      },
      //跳转产品中心
      gotoCenterPage(){
        window.location.href='http://www.wch.cn/products/category/1.html'
      },
      //点击footer的li
      clickFooterLi(t){
        if(t.id){
          if(t.id==69){//其他芯片
            window.location.href='https://www.wch.cn/products/productsCenter/otherChip?categoryId='+t.id
          }else{
            window.location.href='https://www.wch.cn/products/productsCenter/mcuInterface?categoryId='+t.id
          }
        }else{
          window.location.href=t.href
        }
        
      },
      //点击法律声明
      gotoLaw(){
        window.location.href='http://www.wch.cn/statement.html'
      },
      //点击联系我们
      gotoTouch(){
        window.location.href='http://www.wch.cn/contact_us.html'
      },
      //点击CopyRight
      gotoCopyRight(){
        window.location.href='https://beian.miit.gov.cn/#/Integrated/index'
      },
      //点击底部的gif图
      gotoSite(){
        window.location.href='https://uweb.umeng.com/v1/login.php?siteid=1254526631'
      },

      //点击tab切换
      tabClick(tab, event){
           console.log(tab, event);
          //  this.showBanner()
          //  this.showBread()
           if(this.activeName=='first'){
             window.location.href='http://wch.cn/ecosystems?development-tools'
           }
           else if(this.activeName=='second'){
             window.location.href='http://wch.cn/ecosystems?online-training'
           }
           else{
             window.location.href='http://wch.cn/ecosystems?rv-university'
          }
      },
      //判断banner显示
      showBanner(){
        if(this.activeName=='first'){
          this.bannerSrc=require('@/assets/image/tool/banner.png')
        }
        else if(this.activeName=='second'){
          this.bannerSrc=require('@/assets/image/train/banner.png')
        }
        else{
          this.bannerSrc=require('@/assets/image/college/banner.png')
        }
      }
    
    }
  }
</script>
<style scoped >
  .globalLayout{
      background: #f0f0f0;
      width: 100%;
      height: 100%;
  }
  .navbar {
    min-height: 46px;
    width: 100%;
    background: #143657;
   
  }
  .navbar .container{
     display: flex;
     width: calc(100% - 220px);
     margin: 0 auto;
     /* min-height: 36px; */
     height: 46px;
     box-sizing: border-box;
     padding-top: 10px;
  }
  .el-menu--horizontal>.el-submenu /deep/ .el-submenu__title{
    height: 36px;
    line-height: 28px;
    font-size: 17px;
    font-family: 'Noto Sans SC';
    font-weight: 700;
  }
  .el-menu--horizontal>.el-menu-item {
    height: 36px;
    line-height: 28px;
    font-size: 17px;
    font-family: 'Noto Sans SC';
    font-weight: 700;
  }

  .banner{
    margin-top: 104px;
  }

  .navbar .logo{
    width: 18%;
    box-sizing: border-box;
    padding-left: 160px;
  }
  .navbar .dropdown{
    width: 44%;
    display: flex;
    justify-content: space-around;
  }
  .navbar .el-dropdown{
    color: #fff;
    cursor: pointer;
    font-size: 18px;
    font-family: 'Noto Sans SC';
    font-weight: 700;
  }
   .navbar .more {
    height: 32px;
    width: 10%;
    margin-left: 40px;
  }
  .navbar .more .el-select{
    width: 100px;
    height: 32px;
    margin-top: 2px;
  }
  .navbar .more .inputSearch{
    position: relative;
    /* margin- */
  }
  .navbar .more .el-input{
    width: 170px;
  }
  .navbar .more .el-input /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
}
  
  .el-dropdown-menu--small .el-dropdown-menu__item{
    font-size: 15px;
    font-family: 'Noto Sans SC';
    font-weight: 400;
  }
  .navbar .tip{
    display: flex;
    width:15%;
    height: 26px;
    /* background: #fff; */
    margin-left: 70px;
  }
  .navbar .tip .login{
    padding-top:2px;
    color: #fff;
    font-size: 16px;
    margin-left: 5px;
    cursor: pointer;
  }
  .navbar .tip .line{
    background: #fff;
    width: 1px;
    height: 20px;
    margin-left:3px;
    margin-right:3px;
    margin-top: 3px;
  }
  .navbar .tip .register{
    color: #fff;
    font-size: 16px;
    padding-top:2px;
    cursor: pointer;
  }
  .breadCrumb{
    color: #777;
    font-size: 14px;
    font-family: 'Noto Sans SC';
    font-weight: 400;
    width: 100%;
    height: 76px;
  }
  .breadCrumb .breadContainer{
    width: calc(100% - 220px);
    margin: 0 auto ;
    height: 76px;
    padding-top: 26px;
    box-sizing: border-box;
  }
  .footer{
    margin-top: 50px;
    width: 100%;
    /* height: 410px; */
    min-height: 360px;
    background-color: #143657;
    padding-bottom: 20px;
  }
  .footer .content{
    /* width: 1200px; */
    /* width: calc(100% - 700px); */
    width: 63%;
    margin: 0 auto;
    padding-left:15px;
    padding-right:15px;
    padding-top: 60px;

  }
  .footer .content .list{
    display: flex;
    /* justify-content: space-around; */
    justify-content: space-between;
  }
   
   .footer .content .list .listItem .title{
     font-size: 22px;
     color: #ffffff;
     margin:10px 0px;
  }
  .footer .content .list .listItem .splitLine{
    width: 180px;
    margin-bottom: 20px;
    display: flex;
  }
  .footer .content .list .listItem .splitLine .frontLine{
    width: 120px;
    display: block;
    border-bottom: 1px solid #0988e5;
  }
  .footer .content .list .listItem .splitLine .behindLine{
    width: 60px;
    display: block;
    border-bottom: 1px dashed #ffffff;
  }
  .footer .content .list .listItem .lis .li{
    height: 28px;
    font-size: 14px;
    color: #ffffff;
    line-height: 28px;
    letter-spacing: 2px;
    cursor: pointer;
  }
  .footer .content .bottom{
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    height: 20px;
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;
  }
   .footer .content .bottom .right{
    display: flex;
    justify-content: space-between;
  }

 
  /deep/ .el-tabs--card> .el-tabs__header .el-tabs__nav {
   border: 0;
 }
  /deep/ .el-tabs__item{
    font-size: 18px;
    height: 50px;
    line-height: 50px;
    border-radius: 8px;
    margin-right: 10px;
  }
  /deep/ .el-tabs__item.is-active {
    background: #409eff;
    color: #fff;
  }
  .ecoContent{
    width: calc(100% - 220px);
    margin: 0 auto;
    background: white;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 10px;
  }

</style>